<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="chap1">ANGEL</p>
<p class="chap_line"></p>
<p class="center"><span class="big">T</span>here are angels all around us that we simply do not recognize and when being tenderly hugged by your spouse</p>
<p class="center">You are in the arms of an angel.</p>
<p class="center1">When your children wrap their arms around your neck and head on your shoulder You are in the arms of an angel.</p>
<p class="center1">When your pregnant daughter needs to cry on your shoulder</p>
<p class="center">You are in the arms of an angel.</p>
<p class="center1">And when your travails are over and when at the judgement bar your Lord and Savior says to you “Well done true and faithful servant” and holds both your hands</p>
<p class="center">You are in the arms of all the angels.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap009.vue?5d9bfaf8